import { ProfileSectionProps } from "./types";
import { FormSection } from "@/features/common/components/FormSection";
import { DataField } from "@/features/common/components/DataField";
import { TrainingFields } from "./AdditionalQualifications/TrainingFields";
import { LicenseFields } from "./AdditionalQualifications/LicenseFields";

const getMultiSelectLabels = (
  values: string[],
  type: "training" | "license"
) => {
  if (!values || values.length === 0) return null;

  const labelMaps = {
    training: {
      intensivpflege: "Außerklinische Intensiv- und Beatumungspflege",
      heimleitung: "Heimleitung/Einrichtungsleitung",
      intensiv: "Intensiv- und Anästhesiepflege",
      onkologie: "Onkologie",
      operation: "Operations- und Endoskopiedienst",
      palliativ: "Palliativpflege",
      pdl: "Pflegedienstleitung",
      praxisanleitung: "Praxisanleitung",
      psychiatrie: "Psychiatrie / Gerontopsychiatrie",
      qm: "Qualitätsmanagement",
      wbl: "Wohnbereichsleitung",
      wundmanagement: "Wundmanagement"
    },
    license: {
      none: "Nein",
      b: "Führerschein Klasse B",
      c1: "Führerscheinklasse C1 (3,5 t bis 7,5 t)",
      c: "Führerscheinklasse C (> 7,5 t)"
    }
  } as const;

  const labelMap = labelMaps[type] as { [key: string]: string };
  return values.map((value) => labelMap[value] || value).join(", ");
};

export function AdditionalQualificationsSection({
  profile,
  setProfile,
  readOnly
}: ProfileSectionProps) {
  return (
    <FormSection title="Weitere Qualifikationen">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <TrainingFields
          profile={profile}
          setProfile={setProfile}
          readOnly={readOnly}
        />
        <LicenseFields
          profile={profile}
          setProfile={setProfile}
          readOnly={readOnly}
        />
      </div>
    </FormSection>
  );
}

// View component
export function AdditionalQualificationsView({ profile }: { profile: any }) {
  return (
    <div className="space-y-1">
      <DataField
        label="Weiterbildungen"
        value={getMultiSelectLabels(profile.advanced_training, "training")}
      />
      <DataField
        label="Führerschein"
        value={getMultiSelectLabels(profile.drivers_license, "license")}
      />
      <DataField
        label="Deutscher Führerschein"
        value={getMultiSelectLabels(profile.german_drivers_license, "license")}
      />
    </div>
  );
}
